
import { PlusOutlined } from '@ant-design/icons';
import { Input, Row, Col, Select } from 'antd';
import { useState } from 'react';
import { Button, Table } from 'antd';
import '../../LibraryScheduled.css'
import libraryScheduleItemData from './libraryScheduleItemData'
import { useNavigate } from 'react-router-dom';

const { Column } = Table;
const { Search } = Input;

const LibraryScheduledTable = () => {
  const navigate = useNavigate();

  const [tabData, setTabsata] = useState(libraryScheduleItemData);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedStartDate, setselectedStartDate] = useState('Start date');

  const [pageSize, setPageSize] = useState(5);
  const handleSearch = (e) => {
    setSearchKeyword(e.target.value);
  };
  const handleShowMore = () => {
    setPageSize(pageSize + 5);
  };
  const handleStartDateChange = (value) => {
    setselectedStartDate(value);
  }

  const filteredData = tabData.filter((row) => {
    const values = Object.values(row).join(' ').toLowerCase();
    return values.includes(searchKeyword.toLowerCase()) && (selectedStartDate === 'Start date' || row.start_date === selectedStartDate);
  });

  const options2 = [
    { label: 'Start date', value: 'Start date' },
    { label: 'Thursday April 27th 2023', value: 'Thursday April 27th 2023' },
    { label: 'Friday April 28th 2023', value: 'Friday April 28th 2023' },
    { label: 'Monday April 29th 2023', value: 'Monday April 29th 2023' },
    { label: 'Tuesday April 30th 2023', value: 'Tuesday April 30th 2023' },
    { label: 'Wednesday April 26th 2023', value: 'Wednesday April 26th 2023' },
  ];

  return (
    <Row gutter={[0, 40]}>
      <Col span={24} style={{ display: 'flex' }}>
        <Col span={12} style={{ display: 'flex', justifyContent: '' }}>

          <Search
            placeholder="Search"
            allowClear
            onChange={handleSearch}
            style={{
              width: 250
            }}
          />

          <Select value={selectedStartDate} onChange={handleStartDateChange} defaultValue='Start date'
            style={{
              width: 250
            }} options={options2}
          />

        </Col>

        <Col span={12} style={{ display: 'flex', alignItems: 'right', justifyContent: 'end' }}>
          <Button style={{ backgroundColor: '#dddddd', fontWeight: '600' }}>
            <PlusOutlined /> Schedule Workflow
          </Button>
        </Col>
      </Col>


      <Col span={24}>
        <Table className="custom-table"
          dataSource={filteredData} pagination={{ pageSize, showSizeChanger: false }}
          // pagination={false}
          rowKey="key"
          // onChange={handleChange}
          // onRow={(record, rowIndex) => {
          //   return {
          //     onClick: (event) => {
          //       console.log("Clicked Row data :", record);
          //       navigate('library-scheduled/item-page',
          //         { state: { rowData: record } });
          //     },
          //   };
          // }}
          onRow={(record) => {
            return {
              onClick: () =>
                navigate(
                  `/tasks/library/library-scheduled/item-page/${record.key}`
                ),
            };
          }}
        >
          <Column title="NAME" dataIndex="firstName" key="firstName"
            render={(firstName, record) => (
              <div className='fname-styling'>{firstName}</div>
            )}
            width={300}
          />
          <Column title="WORKFLOW" dataIndex="workflow" key="workflow"
            render={(workflow, record) => (
              <div className='workflow-styling'>{workflow}</div>
            )} width={200}

          />
          <Column title="ASSIGNEES" dataIndex="assignees" key="assignees" width={110} />
          <Column title="START DATE" dataIndex="start_date" key="start_date" width={150} />
          <Column title="DUE DATE" dataIndex="due_date" key="due_date" width={150} />

        </Table>
      </Col>
      <Col span={24} >
        <Button onClick={handleShowMore}
          style={{ float: 'right', backgroundColor: '#dddddd', fontWeight: '600' }}>
          Show more
        </Button>
      </Col>
    </Row>

  )
}
export default LibraryScheduledTable;